var map = {
	"./list/index": 301,
	"./list/index.vue": 301
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;


//////////////////
// WEBPACK FOOTER
// ./src/components/page/messages ^\.\/.*$
// module id = 794
// module chunks = 7